import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { TableOptions } from "../../../../shared-kernel/components/Table";
import {
  createAdapterToFieldStateEndpoint,
  createAdapterToState,
  createAdapterToStateEndpoint
} from "../adapters/state.adapter";
import { EndpointStateFiltered, State, StateEndpoint } from "../domain/State.model";
import { appConfig } from "../../../../config";
import { EndpointState } from "../domain/State.model";
import { createAdapterToFilterBackend } from "../../../../utilities/paramsAdapter";

const BASE_STATE_URL = '/estimaciones/estados'
const BASE_STATE_MUTATION_URL = '/estimaciones/estado'
export const BASE_EXPORT_URL = `${appConfig.API_NODE_URL}/estimaciones/estados/export`;

export const stateApi = createApi({
  reducerPath: "stateApi",
  baseQuery: fetchBaseQuery({
    baseUrl: appConfig.API_NODE_URL,
    prepareHeaders: (headers: Headers) => {
      const APP_TOKEN = "app_token";
      const token = localStorage.getItem(APP_TOKEN);

      if (token) {
        headers.set("authorization", `${token}`);
      }

      return headers;
    },
    credentials: "include",
  }),
  refetchOnMountOrArgChange: true,
  tagTypes: ["States", "State"],
  endpoints: (builder) => ({
    getState: builder.query<State, number | undefined>({
      query: (id) => `${BASE_STATE_MUTATION_URL}/${id}`,
      transformResponse: (response: EndpointState) => {
        return createAdapterToState(response.Content)
      },
      providesTags: (_res, _err, id) => [{type: "State", id: id?.toString()}],
    }),
    getStates: builder.query<any, TableOptions<State>|undefined>({
      query: (params: TableOptions<State>) => {
        const { page, pageSize, order, search, filters } = params || {};
        const adaptersFilter = filters?.map( f => createAdapterToFilterBackend(f,createAdapterToFieldStateEndpoint))
        const serializedFilters = adaptersFilter ? JSON.stringify(adaptersFilter) : undefined;
        const serializedOrder = order ? JSON.stringify({field:createAdapterToFieldStateEndpoint(order.field), order:order.order}) : undefined;
        return {
          url:`${BASE_STATE_URL}/filtros`,
          params: {
            page:page? page - 1: 0,
            pageSize,
            order: serializedOrder,
            search,
            filters:serializedFilters
          },
        }
      },
      providesTags: ["States"],
      transformResponse: (response: EndpointStateFiltered, _meta, params: TableOptions<State>) => {
        const page = params?.page ?? 1;
        const endpointResponse = response?.rows?.map((state: StateEndpoint) =>
            createAdapterToState(state)
        );
        return {
          data: endpointResponse,
          page,
          total: response.total,
        };
      },
    }),
    createState: builder.mutation<any, State>({
      query: (data) => ({
        url: `${BASE_STATE_MUTATION_URL}`,
        method: "POST",
        body: {
          "Content": createAdapterToStateEndpoint(data)
        },
      }),
      invalidatesTags: ["States"],
    }),
    updateState: builder.mutation<any, State>({
      query: (data: State) => ({
        url: `${BASE_STATE_MUTATION_URL}`,
        method: "PUT",
        body: {
          "Content": createAdapterToStateEndpoint(data)
        },
      }),
      invalidatesTags: (_res, _err, data: State) => ["States", {type: "State", id: data?.id?.toString()}],
    }),
    deleteState: builder.mutation<void, number>({
      query: (id) => ({
        url: `${BASE_STATE_MUTATION_URL}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["States"],
    }),
  }),
});

export const {
  useGetStateQuery,
  useGetStatesQuery,
  useCreateStateMutation,
  useUpdateStateMutation,
  useDeleteStateMutation
} = stateApi;
